import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ShotHeatMap from '../ShotHeatMap/ShotHeatMap';

const HeatMapModal = ({ isOpen, onClose, history, gameName, filterKey, filterValue, hasHeadTarget = true, plateMode = null }) => {
    const [runLimit, setRunLimit] = useState('');

    if (!isOpen) return null;

    let filteredHistory = filterKey && filterValue 
        ? history.filter(item => item[filterKey] === filterValue)
        : history;

    if (runLimit && parseInt(runLimit, 10) > 0) {
        filteredHistory = filteredHistory.slice(-parseInt(runLimit, 10));
    }

    return (
        <div style={modalOverlayStyle}>
            <div style={modalContentStyle}>
                <div style={modalHeaderStyle}>
                    <h2 style={{ margin: 0 }}>{gameName} Heat Map</h2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label style={{ fontSize: '12px', color: '#ccc' }}>Last runs:</label>
                        <input 
                            type="number" 
                            value={runLimit} 
                            onChange={(e) => setRunLimit(e.target.value)} 
                            placeholder="All" 
                            style={{ width: '60px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #333', background: '#222', color: '#fff' }} 
                        />
                        <button onClick={onClose} style={closeButtonStyle}>×</button>
                    </div>
                </div>
                
                <div style={modalBodyStyle}>
                    <ShotHeatMap history={filteredHistory} hasHeadTarget={hasHeadTarget} plateMode={plateMode} />
                </div>

                <div style={modalFooterStyle}>
                    <div style={{ display: 'flex', gap: '20px', color: '#888', fontSize: '11px' }}>
                        <div>{filteredHistory.length} sessions recorded</div>
                    </div>
                    <button onClick={onClose} style={closeBtnActionStyle}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.85)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(5px)',
};

const modalContentStyle = {
    position: 'relative',
    background: '#1a1a2e', border: '1px solid #2c3e50', borderRadius: '12px',
    width: '90%', maxWidth: '800px', maxHeight: '80%',
    display: 'flex', flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
    color: '#eee',
};

const modalHeaderStyle = {
    padding: '20px', borderBottom: '1px solid #2c3e50',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};

const modalBodyStyle = {
    padding: '20px 20px 40px 20px', overflowY: 'auto', flex: 1,
    display: 'flex', justifyContent: 'center'
};

const modalFooterStyle = {
    padding: '16px 20px', borderTop: '1px solid #2c3e50',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};

const closeButtonStyle = {
    background: 'none', border: 'none', color: '#888', fontSize: '28px',
    cursor: 'pointer', padding: '0 10px',
};

const closeBtnActionStyle = {
    background: '#333', color: '#eee', border: 'none',
    padding: '8px 24px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold',
};

HeatMapModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    history: PropTypes.arrayOf(PropTypes.object).isRequired,
    gameName: PropTypes.string.isRequired,
    filterKey: PropTypes.string,
    filterValue: PropTypes.string,
    hasHeadTarget: PropTypes.bool,
    plateMode: PropTypes.string,
};

export default HeatMapModal;
